import type { ReactNode } from "react";
import styles from "./DesignSystem.module.css";
import { ButtonsSection } from "./sections/Buttons";
import { CardsSection } from "./sections/Cards";
import { ChipsBadgesSection } from "./sections/ChipsBadges";
import { Foundations } from "./sections/Foundations";
import { IdentitySection } from "./sections/Identity";
import { InputsSection } from "./sections/Inputs";
import { NavigationSection } from "./sections/Navigation";
import { StatusSection } from "./sections/Status";
import { TypographySection } from "./sections/Typography";

type SectionProps = {
  label: string;
  title: string;
  children: ReactNode;
};

export const Section = ({ label, title, children }: SectionProps) => (
  <section className={styles.section}>
    <div className={styles.sectionLabel}>{label}</div>
    <h2 className={styles.sectionTitle}>{title}</h2>
    {children}
  </section>
);

export const DesignSystem = () => (
  <main className={styles.page}>
    <h1 className={styles.pageTitle}>Design System</h1>
    <p className={styles.pageSubtitle}>Component playground — every primitive, every variant.</p>
    <Foundations />
    <TypographySection />
    <ButtonsSection />
    <InputsSection />
    <CardsSection />
    <ChipsBadgesSection />
    <StatusSection />
    <IdentitySection />
    <NavigationSection />
  </main>
);
